import styled from 'styled-components'
import phones from '../../../assets/images/phones.png'

export const OnTheGoDiv = styled.div`
min-height: 600px;
display:flex;
justify-content:center;
flex-direction:row;
margin-bottom:-80px;

.firstdiv{
    flex-direction:column;

    span{
        color:#1DCDFE;
    }

    h2{
        color: #02021C;
        font-family: Gilroy;
        font-style: normal;
        font-weight: bold;
        font-size: 42px;
        margin-top:60px;
    }

    p{
        color: #24292E;
    }

    .buttondiv{
        display:flex;
        padding-top:40px;

        button{
            width: 150px;
            height: 45px;
            font-weight: 400;
            font-size: 15px;
            text-align: center;
            border-radius: 10px;
            
        }
        
        .firstbutton{
        
            background: #1DCDFE;
            border:none;
            border-style:hidden;
            :focus{
                box-shadow: none;
            }
            color: #24292E;
            

            
        }
      
        .secondbutton{
            background: #1E90FF;
            border:none;
            border-style:hidden;
            :focus{
                box-shadow: none;
            }
            margin: 0px 15px;
            color: #FFFFFF;
        }
    }
}

.seconddiv{
    img{
        width:450px;
        height:100%;
        margin-top:-30px;
        margin-left:250px;
    }
}

.roww{
    display:flex;
    min-height:550px

 }

@media (max-width:720px){
        .seconddiv{
            display:none;      
        }
        .firstdiv{
            min-height:600px;
            display:flex;
        }
    }

@media (max-width:1024px){
    min-height:700px;
    img{
        width:200px;
        margin-left:200px;
    
    }
}

`
